import React, { useState, useEffect, ChangeEvent } from 'react';
import md5 from 'js-md5';
import closeImage from '@/assets/images/login/inp_close.png';
import luckImage from '@/assets/images/login/code.png';
import phoneImage from '@/assets/images/login/phone.png';
import checkRight from '@/assets/images/login/pwd_checked.png';
import { Form, Input, Button } from 'antd';
import { useHistory, withRouter } from 'react-router-dom';
import useCount from '@/hooks/count';
import { setUserInfo } from '@/store/module/user';
import classnames from 'classnames';
import { getPhoneCodeProps, apiGetPhoneCode, apiGetBindPhone, apiClickBing, apiRegisterReport } from '../server';
import { isTel } from '@/utils';
import '../index.less';
import { getLocalStorage, setLocalStorage } from '@/utils/localStorage';
import {
  LoginProps,
  REPORTED_KEY,
  LOGIN_TRAFFIC_SOURCE_KEY,
  LOGIN_360_PROMOTION_PARAMS_KEY,
  LOGIN_SOURCE_BAIDULK,
  LOGIN_SOURCE_MSCLK,
  LOGIN_SOURCE_YKLK,
  LOGIN_SOURCE_SOUGOULK,
  LOGIN_SOURCE_360LK
} from '../types';
import { connect } from 'react-redux';
import { IStoreState } from '@/store/types';
import Fn from '@/utils/fn';
import StorageFn from '@/utils/electronStorage';
import { lmessage } from '../message';
import HeadBtn from '../components/headBtn';
import { loginCollect } from '@/views/login/collect/loginCollect';
import sdk from '@/utils/Buryingpoint';
import {
  buryOptsForUid,
  callBaiduBusinessUpload,
  isBaiduBusinessUploadAvailable,
  BaiduBusinessIndustrValue
} from '../baiduBusinessReport';
import {
  applyBaidu360RetentionOnLogin,
  getRegisterChannelBuryProps,
  setTrafficSourceFromHisId
} from '../loginRetention';
import { getReportHisIdFromSeo, isTrivialPromoReportHisId, normalizePromoLandingSeoOnLogin } from '../promoLanding';

const COUNT_STATIC = 60;

const INDUSTRY_DISPLAY_AD = 'ocpc_zs_convert' as const;
const INDUSTRY_PC_SEARCH = 'ocpc_ps_convert' as const;
const isSatPczsSourceId = (sourceId: string) => sourceId.startsWith('SATpczs');

type Login360PromotionParams = {
  sourceId?: string;
  jzqs?: string;
  data_industry?: BaiduBusinessIndustrValue;
};

function parseLogin360Promotion(): Login360PromotionParams | null {
  try {
    const raw = getLocalStorage(LOGIN_360_PROMOTION_PARAMS_KEY);
    if (!raw) return null;
    const o = JSON.parse(raw) as Login360PromotionParams;
    return o && typeof o === 'object' ? o : null;
  } catch {
    return null;
  }
}

function LoginBind(props: LoginProps) {
  const [form] = Form.useForm();
  const history: any = useHistory();
  const [mobile, setMobile] = useState<string>('');
  const [isChecked, setIsChecked] = useState<boolean>(false);
  const [canLogin, setCanLogin] = useState<boolean>(false);
  const bind_phone_token: any = history.location?.state?.bind_phone_token;
  const [count, beginTimer, closeTimer] = useCount(COUNT_STATIC);
  const [phoneText, setPhoneText] = useState<string>('');
  const [hisId, setHisId] = useState<string>('');

  useEffect(() => {
    loginCollect(3304, 1);
    const normalizedHisId = normalizePromoLandingSeoOnLogin(getLocalStorage(REPORTED_KEY) || '');
    setHisId(normalizedHisId);
    setTrafficSourceFromHisId(normalizedHisId);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  function changeStatus() {
    const formData = form.getFieldsValue();
    if (formData.phone && isTel(formData.phone) && formData.code) {
      return setCanLogin(true);
    }
    setCanLogin(false);
  }
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const val = value ? value.replace(/[\D]/g, '') : value;
    form.setFieldsValue({
      phone: val
    });
    setMobile(val);
    changeStatus();
  };
  const handlePercentMatchCode = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const val = value ? value.replace(/[\D]/g, '') : value;
    form.setFieldsValue({
      code: val
    });
    changeStatus();
  };
  const onPhoneBlur = () => {
    const formData = form.getFieldsValue();
    if (formData.phone && !isTel(formData.phone)) {
      lmessage.error('手机号格式错误');
    }
  };
  const collectMsclk = async (msclkId: string, bindType: string) => {
    const res = await apiClickBing({
      type: 2,
      clickId: msclkId,
      deviceId: '',
      bingType: bindType
    });
    console.log(res, 111);
  };
  const collectYklk = async (id: string) => {
    const res = await apiRegisterReport({
      clickId: id
    });
    console.log(res, 111);
  };
  const reportRegisteredByHisId = (eventParam?: string | null, buryUid?: string | number) => {
    const uidOpts = buryOptsForUid(buryUid);
    const reportHisId = getReportHisIdFromSeo(hisId || getLocalStorage(REPORTED_KEY) || '');
    const trafficSource = getLocalStorage(LOGIN_TRAFFIC_SOURCE_KEY) || '';
    const promo360 = parseLogin360Promotion();

    if (!reportHisId || isTrivialPromoReportHisId(reportHisId)) {
      if (!getLocalStorage(REPORTED_KEY)) {
        setLocalStorage(LOGIN_TRAFFIC_SOURCE_KEY, '');
      }
      return;
    }
    const paramArr = reportHisId.split('#');
    const reportedId = paramArr[paramArr.length - 1] ? paramArr[paramArr.length - 1] : '';
    if (reportedId !== '1') {
      callBaiduBusinessUpload({ newType: 25 }, uidOpts);
      return;
    }
    if (trafficSource === LOGIN_SOURCE_BAIDULK) {
      callBaiduBusinessUpload({ newType: 25 }, uidOpts);
      return;
    }

    const subChannel = paramArr[1] || '';
    if (trafficSource === LOGIN_SOURCE_MSCLK || subChannel === 'msclk') {
      collectMsclk(paramArr[0], paramArr[2]);
      return;
    }
    if (
      trafficSource === LOGIN_SOURCE_YKLK ||
      trafficSource === LOGIN_SOURCE_SOUGOULK ||
      subChannel === 'yklk' ||
      subChannel === 'sougoulk'
    ) {
      collectYklk(paramArr[0]);
      return;
    }

    const fromPromo360 =
      trafficSource === LOGIN_SOURCE_360LK && promo360 && isSatPczsSourceId(String(promo360.sourceId || ''));
    const fromHisId360 = isSatPczsSourceId(paramArr[0] || '');
    if (fromPromo360 || fromHisId360) {
      let hasJzqs: boolean;
      let industr: BaiduBusinessIndustrValue;
      if (fromPromo360 && promo360) {
        hasJzqs = Boolean(promo360.jzqs);
        if (promo360.data_industry === INDUSTRY_DISPLAY_AD || promo360.data_industry === INDUSTRY_PC_SEARCH) {
          industr = promo360.data_industry;
        } else {
          industr = hasJzqs ? INDUSTRY_DISPLAY_AD : INDUSTRY_PC_SEARCH;
        }
      } else {
        hasJzqs = paramArr.length >= 5 && Boolean(paramArr[3]);
        industr = hasJzqs ? INDUSTRY_DISPLAY_AD : INDUSTRY_PC_SEARCH;
      }
      const payload360 = {
        businessInfo: 'REGISTERED',
        businessType: '1',
        industr,
        businessParam: hasJzqs
          ? {
              trans_id: md5(String(Date.now())),
              event_param: eventParam ?? null
            }
          : null
      };
      callBaiduBusinessUpload(payload360, uidOpts);
      return;
    }

    callBaiduBusinessUpload({ businessInfo: 'REGISTERED', businessType: '1', businessParam: null }, uidOpts);
  };
  const formSubmit = async () => {
    loginCollect(3308, 2);
    let formData = form.getFieldsValue();
    let res: any = await apiGetBindPhone({ ...formData, bindPhoneToken: bind_phone_token });
    if (!res.code) res = res.data;
    if (res.code === 200) {
      if (res.data.userInfo) res.data.userinfo = res.data.userInfo;
      delete res.data.userInfo;
      if (res.data.userinfo.is_register !== 0) {
        loginCollect(3309, 1);
        sdk.Burying({
          uid: res.data.userinfo.id,
          eventname: 'user_register',
          eventtype: 'track',
          properities: getRegisterChannelBuryProps(hisId)
        });
        if (isBaiduBusinessUploadAvailable()) {
          reportRegisteredByHisId(undefined, res.data.userinfo.id);
        }
      }
      applyBaidu360RetentionOnLogin(hisId || getLocalStorage(REPORTED_KEY) || '', res.data.userinfo.id);
      props.setUserInfo(res.data);
      // 关闭登录窗口进入主页
      // 新注册用户进去有引导窗口
      StorageFn.electronDelData('guideModalIsShow');
      Fn.getByRefresh(true);
      // utils.openMain();
    } else {
      lmessage.error(res.msg);
    }
  };
  function onTimerClick() {
    loginCollect(3306, 2);
    form.validateFields().then(async val => {
      const values = val as getPhoneCodeProps;
      if (isTel(values.phone)) {
        let res: any = await apiGetPhoneCode({ phone: values.phone, event: 1, type: 'binding' });
        if (!res.code) res = res.data;
        if (res.code === 200) {
          setIsChecked(true);
          setPhoneText(Fn.phoneEncrypt(values.phone));
          lmessage.success('发送成功');
          beginTimer();
        } else {
          if (res.msg) lmessage.error(res.msg);
        }
      }
    });
  }
  useEffect(
    () => () => {
      closeTimer();
    },
    [] // eslint-disable-line react-hooks/exhaustive-deps
  );
  const focus = () => {
    loginCollect(3305, 3);
  };
  const getFocus = () => {
    loginCollect(3307, 3);
  };
  return (
    <div className="main_position_box">
      <HeadBtn></HeadBtn>
      <div className="login-switch_mold">
        <div className="currnt_f">绑定手机号</div>
      </div>
      <div className="login-form_box" id="login_drop">
        <Form form={form} onFinish={formSubmit} autoComplete="off">
          <Form.Item name="phone">
            <Input
              placeholder="请输入手机号"
              onChange={(e: ChangeEvent<HTMLInputElement>) => handleChange(e)}
              allowClear={{ clearIcon: <img className="phone_icon" src={closeImage} alt="" /> }}
              prefix={<img src={phoneImage} className="phone_icon" alt="" />}
              onBlur={() => onPhoneBlur()}
              onFocus={() => focus()}
            ></Input>
          </Form.Item>
          <div className="login_code_box">
            <Form.Item name="code" className="check_out_box">
              <Input
                className="check_input"
                placeholder="验证码"
                allowClear={{ clearIcon: <img className="phone_icon" src={closeImage} alt="" /> }}
                prefix={<img src={luckImage} className="phone_icon" alt="" />}
                onChange={(e: ChangeEvent<HTMLInputElement>) => handlePercentMatchCode(e)}
                onFocus={() => getFocus()}
                maxLength={4}
              ></Input>
            </Form.Item>
            <Button
              onClick={onTimerClick}
              htmlType="button"
              type="text"
              disabled={COUNT_STATIC !== count || !isTel(mobile)}
              className={classnames('check_inline_text checkbox_text active phone_login_code codebox_text', {
                codebox_active_text: isTel(form.getFieldsValue().phone) || count !== COUNT_STATIC
              })}
            >
              {count === COUNT_STATIC ? '获取验证码' : `${count}秒后重发`}
            </Button>
          </div>
          <div className="check_tips check_tips_text" style={{ visibility: isChecked ? 'visible' : 'hidden' }}>
            <img src={checkRight} className="check_icon" alt="" />
            <span className="check_text">已发送4位验证码至 {phoneText}</span>
          </div>
          <Button
            htmlType="submit"
            className={canLogin ? 'login-form_box__submit_button' : 'login-form_box__submit_button disabled'}
          >
            登录
          </Button>
        </Form>
      </div>
    </div>
  );
}
export default connect(({ settings }: IStoreState) => ({ settings }), { setUserInfo })(withRouter(LoginBind));
